import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getFullName, getInitials } from "@/lib/userUtils";
import { resolveAvatarUrl } from "@/lib/avatarApi";
import { cn } from "@/lib/utils";

/**
 * Org-scoped member avatar. Only uses `member_avatar_url` (never social avatars).
 */
export default function OrgMemberAvatar({
  user,
  memberAvatarUrl,
  className,
  fallbackClassName,
}) {
  const src = resolveAvatarUrl(
    memberAvatarUrl ?? user?.member_avatar_url ?? null
  );
  const label = getFullName(user) || "Member";

  return (
    <Avatar className={cn(className)}>
      {src ? <AvatarImage src={src} alt={label} /> : null}
      <AvatarFallback className={cn(fallbackClassName)}>
        {getInitials(user) || "?"}
      </AvatarFallback>
    </Avatar>
  );
}
